<div class="metrics-container">	
	<div class="metrics-grid">
		<div class="metric-item">
			<div class="metric-header">
				<span class="label">{{'battlinkDevice.perf_analytic.remaining_battery_lifein_ahrs' | translate}}</span>
				<span class="value">{{ percentRemaining | number:'1.0-0' }}%</span>
			</div>
			<div class="progress-bg">
				<div class="progress-fill" [style.width.%]="percentRemaining"></div>
			</div>
		</div>

		<div class="metric-item">
			<div class="metric-header">
				<span class="label">{{'battlinkDevice.perf_analytic.remaining_battery_lifein_years' | translate}}</span>
				<span class="value">{{ yearsRemaining | number:'1.1-1' }} Yrs</span>
			</div>
			<div class="progress-bg">
				<div class="progress-fill" [style.width.%]="percentRemainingYears"></div>
			</div>
		</div>
	</div>
</div>